<template>
    <div class="article-page">
        <kw-common-pc-topbar contentwidth="1150"></kw-common-pc-topbar>
        <Frame class='article-module' name="案例分享">
            <div class='article-content'>
                <div class='article-content-inner'>
                    <h3>{{article_info.title_text}}</h3>
                    <div v-html="content"></div>
                </div>
            </div>
        </Frame>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import Frame from '@components/commonFramework/newIndex'
import FootBar from '@components/footBar'
import { cookies } from '@utils'
export default {
    data() {
        return {
            article_info: {},
            content: ''
        }
    },
    async created() {
        cookies.set('_platform_code', 1)
        cookies.set('_business_tag', 'businessportal')
        this.$store.dispatch('getUserInfo')
        const id = this.$route.params.id
        const json = await this.$store.dispatch('article/getArticleDetail', { artId: id})
        if (json && json.code === 1001) {
            const { article_info = {}, content_info = {}} = json.data
            this.article_info = article_info
            this.content = content_info.content || ''
        }
    },
    components: {
        Frame,
        FootBar
    }
}
</script>
<style lang="scss" scoped>
.article-page{
    .article-content{
        // width: 1180px;
        // margin: 20px 0;
        background: #fff;
        box-shadow: 0 2px 4px 0 rgba(2,2,2,.1);
        padding: 20px;

        .article-content-inner{
            padding: 28px 35px;
        }

        h3{
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 22px;
            color: #000;
            line-height: 1.2;
            margin-bottom: 36px;
        }
    }
}
</style>
